// requiring html templates so that hot reloading works
const template = require('./dateTimePopUp.html');

const NS = 'DateTimePopUp'; // jshint ignore:line

const fourDigitRegex = /^\d{4}$/;

/**
 * This appears directly on the index.html and is triggered by the 'datesSelector.directive' and 'dateTimeButton.directive'.
 * But a different date picker is used on the main timeline view's date picker (DatePickerDialogCtrl).
 */

export default function DateTimePopUp($rootScope) { // as dateTimePopUp
  "ngInject";

  return {
    controller: function () {
    },
    template,
    link,
    restrict: 'E',
    scope: {}
  };

  function link(scope) {
    $rootScope.$on('open-date-time-picker', open);
    scope.close = close;
    scope.save = save;

    function open(evt, targetEvent, scopeObj, property, mode, maxDate) {

      scope.scopeObj = scopeObj;
      scope.property = property;
      scope.date = scope.scopeObj[scope.property];
      scope.mode = mode;
      scope.open = true;
      scope.maxDate = maxDate;
    }

    function close() {
      scope.open = false;
    }

    function save(newDate) {
      const year = newDate.getFullYear();
      // We could enter 5 digit year - which was creating error - We need to restrict to 4 digits - So the popup will not close unless its a 4 digit year
      if ((fourDigitRegex).test(year)) {
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        scope.scopeObj[scope.property] = newDate;
        scope.open = false;
        $rootScope.$broadcast('dateChangedInDirective', scope.property, newDate);
      } else {
        scope.open = true;
      }
    }
  }
}
